// extracted by mini-css-extract-plugin
module.exports = {"ProductInfo":"styles_ProductInfo__70Lhi","mainImage":"styles_mainImage__EwBsF","texts":"styles_texts__lehD9"};